import { VDivider } from 'vuetify/lib/components/VDivider';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.machine_template_list),function(item,index){return _c('div',{key:index,staticClass:"machine-item",on:{"click":function($event){return _vm.machine_template_selected(item)}}},[_c('div',{staticClass:"d-flex px-4 py-3"},[_c('p',{staticStyle:{"margin-bottom":"0px"}},[_vm._v(" "+_vm._s(item.machine_template_name)+" ")])]),_c('div',{staticClass:"px-2"},[_c(VDivider)],1)])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }